import { render, staticRenderFns } from "./FormControlOdpCourseDatesEvent.vue?vue&type=template&id=b7c8a186"
import script from "./FormControlOdpCourseDatesEvent.vue?vue&type=script&setup=true&lang=js"
export * from "./FormControlOdpCourseDatesEvent.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports